import type { Option } from '../QuestionScreen/QuestionScreen'

export type QuestionConfig = {
  question: string
  shortQuestion: string // used for analytics
  options: (Option & {
    filter: Record<string, any>
  })[]
}

export const budgetQuestionsAndFilters: QuestionConfig = {
  question:
    "What is the maximum price you're willing to pay? We'll only show you laptops that cost less than this",
  shortQuestion: 'maximum price',
  options: [
    {
      label: '£500',
      filter: {
        price: {
          from: ['0'],
          to: ['500'],
        },
      },
    },
    {
      label: '£1000',
      filter: {
        price: {
          from: ['0'],
          to: ['1000'],
        },
      },
    },
    {
      label: '£1500',
      filter: {
        price: {
          from: ['0'],
          to: ['1500'],
        },
      },
    },
    {
      label: 'No limit',
      filter: {
        price: {
          from: ['0'],
        },
      },
    },
  ],
}

export const osQuestionsAndFilters: QuestionConfig = {
  question: 'What operating system do you want your laptop to run?',
  shortQuestion: 'operating system',
  options: [
    {
      label: 'Windows',
      filter: {
        laptop_type: {
          type: ['Windows'],
        },
      },
    },
    {
      label: 'macOS',
      filter: {
        laptop_type: {
          type: ['MacBook'],
        },
      },
    },
    {
      label: 'Chrome OS',
      filter: {
        laptop_type: {
          type: ['Chromebook'],
        },
      },
    },
    {
      label: 'No preference',
      filter: {
        laptop_type: {
          type: ['Windows', 'MacBook', 'Chromebook'],
        },
      },
    },
  ],
}

export const usecaseQuestionsAndFilters: QuestionConfig = {
  question: 'To help us find a model, what do you need your laptop for?',
  shortQuestion: 'primary use',
  options: [
    {
      label: 'Simple tasks',
      filter: {
        'minimum memory (ram)': {
          ram: ['4-128'],
        },
        test_results: {
          performance: ['3'],
        },
      },
      tooltip:
        "For simple web browsing and some basic tasks where you won't need many programs open at once",
    },
    {
      label: 'Study',
      filter: {
        'minimum memory (ram)': {
          ram: ['8-128'],
        },
        test_results: {
          performance: ['3'],
        },
      },
      tooltip:
        'For school, university or personal study, see laptops with enough Ram to keep things running smoothly',
    },
    {
      label: 'Creativity/work',
      filter: {
        'minimum memory (ram)': {
          ram: ['8-128'],
        },
        test_results: {
          performance: ['5'],
          screen_performance: ['4'],
        },
      },
      tooltip:
        "For media editing or using multiple programs at once, we'll look for enough memory and a top performance score",
    },
    {
      label: 'High power jobs',
      filter: {
        'minimum memory (ram)': {
          ram: ['16-128'],
        },
        test_results: {
          performance: ['5'],
          screen_performance: ['4'],
        },
      },
      tooltip:
        "For high-intensity tasks, we'll show you laptops with over 16GB of Ram and top-tier performance",
    },
  ],
}
